import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  Row,
  Col,
  CardTitle,
  CardBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Table,
  Spinner,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { apiService } from "../../constants/ApiService";
import VendorBranchSelector from "../../components/VendorBranchSelector";
import { toast } from "react-toastify";
import useVendorBranch from "../../utils/useVendorBranch";
import conditionalDataLoad from "../../utils/conditionalDataLoad";
import { useSelector } from "react-redux";
import Select from "react-select";
import { formatDate } from "../../constants/DateFormatter";

const FeeDefaulterReport = ({ systemData }) => {
  const { user } = useSelector((state) => state.authState);
  const navigate = useNavigate();
  const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
    useVendorBranch(user);
  const [selectionData, setSelectionData] = useState({
    vendor_id: "",
    branch_id: "",
  });
  const [errorMessage, setErrorMessage] = useState({});
  const [Fee_Reciept_Master_data, setFee_Reciept_Master_data] = useState([]);
  const [totalCollection, setTotalCollection] = useState(0);
  const [classMasterData, setClassMasterData] = useState([]);
  const [batchMasterData, setBatchMasterData] = useState([]);
  const [search, setSearch] = useState("");
  //const [fromDate, setFromDate] = useState(new Date().toISOString().split("T")[0]);
  const [asOnDate, setAsOnDate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [classId, setClassId] = useState(0);
  const [batchId, setBatchId] = useState(0);
  const [order, setOrder] = useState("adm_no");
  const [loading, setLoading] = useState(false);

  const fetchBatches = async (course_selection_id = 0, searchText = "") => {
    //setBatches([]);

    try {
      const res = await apiService.get(
        `api/BatchMaster/GetAllBatch?vendorId=${selectionData.vendor_id}&branchId=${selectionData.branch_id}&classId=${course_selection_id}&search=${encodeURIComponent(
          searchText,
        )}`,
      );

      if (res.status === true) {
        const list = res.data || [];
        setBatchMasterData(
          list?.map((x) => ({
            value: x.id,
            label: x.batch_code ? `${x.batch_code}` : "Batch code not found",
          })),
        );
      } else {
        toast.error(res.message || "Failed to fetch batches");
      }
    } catch (err) {
      console.log(err);
      toast.error("Failed to load batches");
    }
  };

  const GetCurrectClassInfo = async (searchText = "") => {
    try {
      const res = await apiService.get(
        `api/ClassMaster/GetClassMaster?vendorId=${selectionData.vendor_id}&branchId=${selectionData.branch_id}&searchItem=${encodeURIComponent(
          searchText || "",
        )}`,
      );

      if (res.status === true) {
        const classesRaw = res?.data;

        const classOptions = (classesRaw || []).map((x) => ({
          value: x.id,
          label: x.class_Name ?? x.class_display_name ?? "No Name",
        }));

        setClassMasterData(classOptions);
      } else {
        toast.error(res.message || "Failed to fetch");
      }
    } catch (error) {
      console.log(error);
      alert("SomeThing went wrong");
    }
  };

  const fetchData = async () => {
    // Guard: don't hit the API until a batch has been selected.
    if (!batchId) {
      setFee_Reciept_Master_data([]);
      setTotalCollection(0);
      return;
    }

    setLoading(true);
    try {
      const queryParams = new URLSearchParams();
      if (search) queryParams.append("search", search);
      if (asOnDate) queryParams.append("asOnDate", asOnDate);
      if (batchId) queryParams.append("batchId", batchId);
      if (selectionData.vendor_id)
        queryParams.append("vendorId", selectionData.vendor_id);
      if (selectionData.branch_id)
        queryParams.append("branchId", selectionData.branch_id);

      const response = await apiService.get(
        `api/FeeReciept/GetFeeDefaulters?${queryParams.toString()}`,
      );
      if (response.status === true) {
        const respData = response.data;
        setFee_Reciept_Master_data(respData);

        const tot = respData.reduce(
          (sum, x) => sum + Number(x.totalDue || 0),
          0,
        );
        setTotalCollection(tot);
      } else {
        toast.error(response.message || "Failed to fetch data");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }

    setLoading(false);
  };

  // Single effect: loads class/batch dropdown data, and only calls
  // fetchData (guarded above) once a batch is actually selected.
  useEffect(() => {
    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: selectionData.vendor_id,
      branchId: selectionData.branch_id,
    });

    if (!canLoad) return;

    GetCurrectClassInfo();
    fetchBatches(classId);
    fetchData();
  }, [
    search,
    classId,
    batchId,
    asOnDate,
    selectionData.vendor_id,
    selectionData.branch_id,
  ]);

  const tableRef = useRef();

  const handlePrint = () => {
    const printContent = tableRef.current.innerHTML;
    const newWindow = window.open("", "_blank");

    newWindow.document.write(`
    <html>
      <head>
        <title>Print Table</title>
        <style>
          table { width: 100%; border-collapse: collapse; }
          th, td { border: 1px solid black; padding: 8px; text-align: left; }
          th { background-color: #d5f3f2; }
           /* Hide column with 'no-print' class when printing */
            @media print {
              .no-print { display: none; }
               .col-normal { display: none; }
               .col-print { display: table-cell !important; }
            }
        </style>
      </head>
      <body>
        <h2 style="text-align:center;color:green">${systemData.school_name}</h2>
        <h3 style="text-align:center;color:blue">Fee Defaulter List</h3>
        <p style="text-align:end;">Class :- ${classId ? classId : "ALL"}</p>
        <p style="text-align:end;"> As on Date :- ${asOnDate ? asOnDate : "---"}</p>
        ${printContent}
          <script>
            window.onload = function() {
              window.print();
              window.onafterprint = function() { window.close(); };
              setTimeout(() => { window.close(); }, 100); // Fallback close in case onafterprint fails
            };
          </script>
      </body>
    </html>
  `);

    newWindow.document.close();
  };

  return (
    <>
      <div className="text-right mb-2">
        <Button
          onClick={handlePrint}
          className="btn btn-warning"
          disabled={!batchId}
        >
          <i className="bi bi-printer mr-2" /> Print Defaulter Report
        </Button>
        &nbsp;
      </div>

      <VendorBranchSelector
        user={user}
        selectionData={selectionData}
        setSelectionData={setSelectionData}
        errorMessage={errorMessage}
        accessButton={true}
      />

      <Card className="card-box height-100-p pd-20 mb-20">
        {/* Header */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 gap-3">
          {/* Title */}
          <div>
            <h4 className="fw-bold text-primary mb-1">
              <i className="bi bi-currency-rupee mr-2"></i> Fee Defaulter Report
            </h4>
            <small className="text-muted">
              Showing{" "}
              <span className="fw-semibold">
                {Fee_Reciept_Master_data.length}
              </span>{" "}
              records
            </small>
          </div>
        </div>

        {/* Filters */}
        <div className="row g-3 mb-4">
          {/* Filter Label */}
          <Col md="4">
            <Label className="mb-1">As on Date</Label>
            <input
              name="asOnDate"
              type="date"
              value={asOnDate}
              onChange={(e) => setAsOnDate(e.target.value)}
              className="form-control"
            />
          </Col>

          <Col md="4">
            <Label className="mb-1">Select a Course</Label>
            <Select
              options={classMasterData}
              value={classMasterData.find((o) => o.value === classId) || null}
              onChange={(option) => {
                if (option) {
                  setClassId(option.value);
                } else {
                  setClassId(null);
                }
                setBatchId(null); // reset batch when class changes
              }}
              onInputChange={(inputValue, actionMeta) => {
                if (actionMeta.action === "input-change") {
                  GetCurrectClassInfo(inputValue);
                }
              }}
              isSearchable
              isClearable
              placeholder="Search courses ..."
              styles={{
                control: (base) => ({ ...base, height: "46px" }),
              }}
            />
          </Col>

          <Col md="4">
            <Label className="mb-1">
              Select a Batch <span className="text-danger">*</span>
            </Label>
            <Select
              options={batchMasterData}
              value={batchMasterData.find((x) => x.value === batchId) || null}
              onChange={(option) => {
                if (option) {
                  setBatchId(option.value);
                } else {
                  setBatchId(null); // cleared
                }
              }}
              onInputChange={(inputValue, actionMeta) => {
                if (actionMeta.action === "input-change") {
                  fetchBatches(classId, inputValue);
                }
              }}
              isSearchable
              isClearable
              placeholder="Search batches ..."
              styles={{
                control: (base) => ({ ...base, height: "46px" }),
              }}
            />
          </Col>
        </div>

        <CardBody>
          {!batchId ? (
            <div className="text-center text-muted py-5">
              <i className="bi bi-info-circle mr-2"></i>
              Please select a batch first to load the fee defaulter report.
            </div>
          ) : loading ? (
            <div className="d-flex justify-content-center align-items-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden"></span>
              </div>
            </div>
          ) : (
            <div ref={tableRef} className="table-responsive">
              <Table hover striped className="compact-table">
                <thead>
                  <tr>
                    <th>Sno.</th>
                    <th>Enroll no.</th>
                    <th>Student Name</th>
                    <th>Father Name</th>
                    {user?.working_bussinesss_mode !== "SCHOOL" && (
                      <th className="text-center">Pending Installments</th>
                    )}
                    <th className="text-right">Oldest Due Date</th>
                    <th className="text-right">Due Amt</th>
                  </tr>
                </thead>
                <tbody>
                  {Fee_Reciept_Master_data.length > 0 ? (
                    <>
                      {Fee_Reciept_Master_data?.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>
                            {user?.working_bussinesss_mode === "SCHOOL"
                              ? item.admit_no
                              : item.enrollment_number}
                          </td>
                          <td>{item.student_name}</td>
                          <td>{item?.f_name}</td>

                          {user?.working_bussinesss_mode !== "SCHOOL" && (
                            <td className="text-center">
                              {item.pendingInstallments}
                            </td>
                          )}
                          <td className="text-right">
                            {formatDate(item.oldestDueDate)}
                          </td>
                          <td className="text-right">₹{item.totalDue}</td>
                        </tr>
                      ))}

                      <tr>
                        <td
                          className="col-normal text-right"
                          colSpan={5}
                          style={{ fontWeight: "bold" }}
                        >
                          Total :{" "}
                        </td>
                        <td
                          className="text-right"
                          style={{ fontWeight: "bold" }}
                        >
                          ₹{totalCollection}
                        </td>
                      </tr>
                    </>
                  ) : (
                    <>
                      <tr>
                        <td colSpan={7} style={{ textAlign: "center" }}>
                          No data available
                        </td>
                      </tr>
                    </>
                  )}
                </tbody>
              </Table>
            </div>
          )}
        </CardBody>
      </Card>
    </>
  );
};

export default FeeDefaulterReport;